import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  tags: [],
  uras: [],
  filas: [],
  regex: [],
  rotas: [],
  audios: [],
  troncos: [],
  webhooks: [],
  conferencias: [],
  centroDeCustos: [],
  musicasEmEspera: [],
  gruposAtendimento: [],
  avaliacoesAtendimento: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
